import { combineReducers } from "redux";
import login from "./slices/backend/login";
import itemConfiguracion from "./slices/backend/itemConfiguracion";
import itemTareaCatalogo from "./slices/backend/itemTareaCatalogo";
import itemContrato from "./slices/backend/itemContrato";
import itemClientePorContrato from "./slices/backend/itemClientePorContrato";
import itemPonderacion from "./slices/backend/itemPonderacion";
import itemSaldoClearing from "./slices/backend/itemSaldoClearing";
import itemConsumoPorCaso from "./slices/backend/itemConsumoPorCaso";
import itemAcountManagerSaldoClearing from "./slices/backend/itemAcountManagerSaldoClearing";
import itemClienteResultado from "./slices/backend/itemClienteResultado";
import tareaResolver from "./slices/backend/tareaResolver";
import ticketInsertar from "./slices/backend/ticketInsertar";
import tareaTomarLiberar from "./slices/backend/tareaTomarLiberar";
import tareaTomarLiberarOperador from "./slices/backend/tareaTomarLiberarOperador";
import ticketModificar from "./slices/backend/ticketModificar";
import itemCatalogoPorIdTareaCatalogo from "./slices/backend/itemCatalogoPorIdTareaCatalogo";
import itemProcesoPorCliente from "./slices/backend/itemProcesoPorCliente";
import itemTipoTicketPorCliente from "./slices/backend/itemTipoTicketPorCliente";
import itemCasoPorId from "./slices/backend/casoPorId";
import itemCategoriaPorId from "./slices/backend/categoriaPorId";
import listaCasosActivosPorContrato from "./slices/backend/listaCasosActivosPorContrato";
import listaCasosArchivadosPorContrato from "./slices/backend/listaCasosArchivadosPorContrato";
import itemContratoAdministrados from "./slices/backend/itemContratoAdministrados";
import itemCasoActivoPorIdContext from "./slices/backend/casoActivoPorIdContext";
import itemCasoArchivadoPorId from "./slices/backend/casoArchivadoPorId";
import itemCasoArchivadoPorIdContext from "./slices/backend/casoArchivadoPorIdContext";
import itemCasosPorClientet from "./slices/backend/casosPorCliente";
import itemComentariosCasoActivo from "./slices/backend/comentariosCasoActivo";
import itemComentariosCasoArchivado from "./slices/backend/comentariosCasoArchivado";
import itemListaCasosArchivado from "./slices/backend/listaCasosArchivado";
import itemListaCasosActivo from "./slices/backend/listaCasosActivo";
import itemListaTareasAbiertasPorUsuario from "./slices/backend/listaTareasAbiertasPorUsuario";
import itemListaTareasCompletadasPorUsuario from "./slices/backend/listaTareasCompletadasPorUsuario";
import itemListaTareasTomadasPorUsuario from "./slices/backend/listaTareasTomadasPorUsuario";
import itemRecursoContexto from "./slices/backend/recursoContexto";
import itemTareasCasoArchivado from "./slices/backend/tareasCasoArchivado";
import itemTareasCasoActivo from "./slices/backend/tareasCasoActivo";
import itemUltimaTareaCasoActivo from "./slices/backend/ultimaTareaCasoActivo";
import obtenerUsuarios from "./slices/backend/obtenerUsuarios";
import casosActivadosAllContratos from "./slices/backend/listaCasosActivosAllContratos";
import casosArchivadosAllContratos from "./slices/backend/listaCasosArchivadosAllContratos";
import serviceRequestActivoStorgeId from "./slices/backend/serviceRequestActived";
import serviceRequestArchivadosStorgeId from "./slices/backend/serviceRequestArchived";
import TareasAbiertasTomadasPorUsuario from "./slices/backend/listaTareasAbiertasTomadasPorUsuario";
import TareasAbiertasPorUsuario from "./slices/backend/listaTareasAbiertasPorUsuario";
import TareasCompletadasCasoPorUsuario from "./slices/backend/listaTareasCompletadasCasoPorUsuario";
import TareasCompletadasPorCaso from "./slices/backend/listaTareasCompletadasPorCaso";
import TareasCompletadasPorUsuario from "./slices/backend/listaTareasCompletadasPorUsuario";
import TareasEnEjecucionCaso from "./slices/backend/listaTareasEnEjecucionCaso";
import TareasNoTomadasCaso from "./slices/backend/listaTareasNoTomadasCaso";
import TareaPorId from "./slices/backend/tareaPorId";
import TareaPorIdRedirect from "./slices/backend/tareaPorIdRedirect";
import listaTareasCompletadasUsuario from "./slices/backend/listaTareasCompletadasUsuario";
import listaTareasAbiertasTomadasUsuario from "./slices/backend/listaTareasAbiertasTomadasUsuario";
import listaTareasAbiertasPorIdUsuario from "./slices/backend/listaTareasAbiertasPorIdUsuario";
import listaTareasActivasCasoPorUsuario from "./slices/backend/listaTareasActivasCasoPorUsuario";
import tareaTiempoRef from "./slices/backend/tareaTiempoRef";
import tareaTiempoEstimRef from "./slices/backend/tareaTiempoEstimRef";
import actualizarNotificaciones from "./slices/backend/actualizarNotificaciones";
import obtenerNotificaciones from "./slices/backend/obtenerNotificaciones";
import TareasAbiertasPorUsuarioCaso from "./slices/backend/listaTareasAbiertasPorUsuarioCaso";
import obtenerTiposPausa from "./slices/backend/obtenerTiposPausa";
import itemClienteResultados from "./slices/backend/itemClienteResultados";
import actualizarDisponibilidad from "./slices/backend/actualizarDisponibilidad";
import pausarTarea from "./slices/backend/pausarTarea";
import reiniciarTarea from "./slices/backend/reiniciarTarea";
import TareasRecurso from "./slices/backend/listaTareasRecurso";
import TareaIdRecurso from "./slices/backend/listaTareaIdRecurso";
import pasusaExcedida from "./slices/backend/pausaExcedida";
import tareasRecursoTomadas from "./slices/backend/listaTareasTomadasRecurso";
import insertarGuardia from "./slices/backend/insertarGuardia";
import modificarGuardia from "./slices/backend/modificarGuardia";
import obtenerGuardia from "./slices/backend/obtenerGuardia";
import obtenerGuardiaRealizada from "./slices/backend/obtenerGuardiaRealizada";
import obtenerGuardiaCancelada from "./slices/backend/obtenerGuardiaCancelada";
import respuestaPausaExcedida from "./slices/backend/respuestaPausaExcedida";
import usuariosGuardia from "./slices/backend/obtenerUsuariosGuardia";
import obtenerCategorias from "./slices/backend/obtenerCategorias";
import tareaOperadorRef from "./slices/backend/tareaOperadorRef";
import listaTareaRm from "./slices/backend/obtenerTareasRm";
import asignarTareaManual from "./slices/backend/asignarTareaManual";
import obtenerUsuariosTorre from "./slices/backend/obtenerUsuariosTorre";
import pausaDiaria from "./slices/backend/obtenerPausaDiaria";
import estadoTareas from "./slices/backend/obtenerEstadoTareas";
import acreditarHs from "./slices/backend/acreditarHs";
import tareaResolverOperador from "./slices/backend/tareaResolverOperador";
import listaEstadoUsuarios from "./slices/backend/obtenerEstadoUsuarios";
import obtenerAdjuntosCaso from "./slices/backend/obtenerAdjuntosCaso";
import recuperarArchivoAdjunto from "./slices/backend/recuperarArchivoAdjunto";
import obtenerArchivoAdjunto from "./slices/backend/obteneArchivo";
import adjuntarArchivo from "./slices/backend/adjuntarArchivo";
import adjuntosIngresarArchivo from "./slices/backend/adjuntosIngresarArchivo";
import obtenerTiposMime from "./slices/backend/obtenerTiposMime";
import ultimaTareaCasosActivosCliente from "./slices/backend/ultimaTareaCasosActivosCliente";
import obtenerCustomFieldsContrato from "./slices/backend/obtenerCustomFieldsContrato";
import obtenerEstadoUsuario from "./slices/backend/obtenerEstadoUsuario";
import asignarTareaAutomaticamente from "./slices/backend/asignarTareaAutomaticamente";
import movimientosCasoActivo from "./slices/backend/movimientosCasoActivo";
import ingresarInsumoTiempo from "./slices/backend/ingresarInsumoTiempo";
import obtenerUsuario from "./slices/backend/obtenerUsuario";
import tareasPorCaso from "./slices/backend/tareasPorCaso";
import modificarCasoPrioridad from "./slices/backend/modificarCasoPrioridad";
import obtenerEntradasFiltradas from "./slices/backend/obtenerEntradasFiltradas";
import insertarEvento from "./slices/backend/insertarEvento";
import modificarEvento from "./slices/backend/modificarEvento";
import eliminarEvento from "./slices/backend/eliminarEvento";
import obtenerEventos from "./slices/backend/obtenerEventos";
import obtenerEvento from "./slices/backend/obtenerEvento";
import insertarTipoNotificacion from "./slices/backend/insertarTipoNotificacion";
import modificarTipoNotificacion from "./slices/backend/modificarTipoNotificacion";
import eliminarTipoNotificacion from "./slices/backend/eliminarTipoNotificacion";
import obtenerTipoNotificacion from "./slices/backend/obtenerTipoNotificacion";
import obtenerTiposNotificaciones from "./slices/backend/obtenerTiposNotificaciones";
import modificarVariableNotificacion from "./slices/backend/modificarVariableNotificacion";
import obtenerVariablesNotificaciones from "./slices/backend/obtenerVariablesNotificaciones";
import obtenerVariableNotificacion from "./slices/backend/obtenerVariableNotificacion";
import actualizarConfiguracionNotificacion from "./slices/backend/actualizarConfiguracionNotificacion";
import obtenerConfiguracionesNotificacion from "./slices/backend/obtenerConfiguracionesNotificacion";
import obtenerPerfiles from "./slices/backend/obtenerPerfiles";
import obtenerEntradas from "./slices/backend/entradasFiltradas";
import ponderacionesUsuarios from "./slices/backend/ponderacionesUsuarios";
import modificarUsuario from "./slices/backend/modificarUsuario";
import obtenerConfiguracionesNotificacionPerfil from "./slices/backend/obtenerConfiguracionesNotificacionPerfil";
import busquedaCasosTareas from "./slices/backend/busquedaCasosTareas";
const rootReducers = combineReducers({
  login: login,
  busquedaCasosTareas: busquedaCasosTareas,
  obtenerConfiguracionesNotificacion: obtenerConfiguracionesNotificacion,
  obtenerConfiguracionesNotificacionPerfil: obtenerConfiguracionesNotificacionPerfil,
  itemCasoPorId: itemCasoPorId,
  obtenerTipoNotificacion: obtenerTipoNotificacion,
  obtenerTiposNotificaciones: obtenerTiposNotificaciones,
  tareaTiempoRef: tareaTiempoRef,
  tareaTiempoEstimRef: tareaTiempoEstimRef,
  tareaOperadorRef: tareaOperadorRef,
  tareaPorId: TareaPorId,
  serviceRequestActivoStorgeId: serviceRequestActivoStorgeId,
  serviceRequestArchivedStorgeId: serviceRequestArchivadosStorgeId,
  insertarEvento: insertarEvento,
  modificarEvento: modificarEvento,
  eliminarEvento: eliminarEvento,
  obtenerEventos: obtenerEventos,
  obtenerEvento: obtenerEvento,
  insertarTipoNotificacion: insertarTipoNotificacion,
  modificarTipoNotificacion: modificarTipoNotificacion,
  eliminarTipoNotificacion: eliminarTipoNotificacion,
  modificarVariableNotificacion: modificarVariableNotificacion,
  obtenerVariablesNotificaciones: obtenerVariablesNotificaciones,
  obtenerVariableNotificacion: obtenerVariableNotificacion,
  actualizarConfiguracionNotificacion: actualizarConfiguracionNotificacion,

  obtenerPerfiles: obtenerPerfiles,
  tareaPorIdRedirect: TareaPorIdRedirect,
  ponderacionesUsuarios: ponderacionesUsuarios,
  itemTareasCasoArchivado: itemTareasCasoArchivado,
  actualizarDisponibilidad: actualizarDisponibilidad,
  itemUltimaTareaCasoActivo: itemUltimaTareaCasoActivo,
  listaTareasCompletadasPorCaso: TareasCompletadasPorCaso,
  itemConsumoPorCaso: itemConsumoPorCaso,
  obtenerEntradas: obtenerEntradas,
  obtenerEntradasFiltradas: obtenerEntradasFiltradas,
  modificarCasoPrioridad: modificarCasoPrioridad,
  ingresarInsumoTiempo: ingresarInsumoTiempo,
  obtenerUsuario: obtenerUsuario,
  tareasPorCaso: tareasPorCaso,
  itemCatalogoPorIdTareaCatalogo: itemCatalogoPorIdTareaCatalogo,
  itemCategoriaPorId: itemCategoriaPorId,
  itemTareaCatalogo: itemTareaCatalogo,
  itemCasoActivoPorIdContext: itemCasoActivoPorIdContext,
  ticketInsertar: ticketInsertar,
  obtenerCustomFieldsContrato: obtenerCustomFieldsContrato,
  tareaTomarLiberar: tareaTomarLiberar,
  obtenerAdjuntosCaso: obtenerAdjuntosCaso,
  adjuntarArchivo: adjuntarArchivo,
  adjuntosIngresarArchivo: adjuntosIngresarArchivo,
  obtenerEstadoUsuario: obtenerEstadoUsuario,
  movimientosCasoActivo: movimientosCasoActivo,
  itemContratoAdministrados: itemContratoAdministrados,
  itemConfiguracion: itemConfiguracion,
  asignarTareaManual: asignarTareaManual,
  obtenerNotificaciones: obtenerNotificaciones,
  asignarTareaAutomaticamente: asignarTareaAutomaticamente,
  obtenerUsuariosTorre: obtenerUsuariosTorre,
  ultimaTareaCasosActivosCliente: ultimaTareaCasosActivosCliente,
  tareasAbiertasPorIdUsuario: listaTareasAbiertasPorIdUsuario,
  itemListaTareasAbiertasPorUsuario: itemListaTareasAbiertasPorUsuario,
  listaTareasAbiertasPorUsuario: TareasAbiertasPorUsuario,
  obtenerTiposMime: obtenerTiposMime,
  obtenerArchivoAdjunto: obtenerArchivoAdjunto,
  recuperarArchivoAdjunto: recuperarArchivoAdjunto,
  itemClientePorContrato: itemClientePorContrato,
  tareaIdRecurso: TareaIdRecurso,
  listaEstadoUsuarios: listaEstadoUsuarios,
  listaTareasRecurso: TareasRecurso,
  tareaResolver: tareaResolver,
  tareaResolverOperador: tareaResolverOperador,
  tareaTomarLiberarOperador: tareaTomarLiberarOperador,
  listaCasosArchivadosPorContrato: listaCasosArchivadosPorContrato,
  listaCasosActivosPorContrato: listaCasosActivosPorContrato,
  itemCasosActivosAllContratos: casosActivadosAllContratos,
  itemCasosArchivadosAllContratos: casosArchivadosAllContratos,
  itemListaCasosActivo: itemListaCasosActivo,
  acreditarHs: acreditarHs,
  estadoTareas: estadoTareas,
  pausaDiaria: pausaDiaria,
  listaTareaRm: listaTareaRm,
  itemContrato: itemContrato,
  obtenerCategorias: obtenerCategorias,
  usuariosGuardia: usuariosGuardia,
  respuestaPausaExcedida: respuestaPausaExcedida,
  insertarGuardia: insertarGuardia,
  modificarGuardia: modificarGuardia,
  obtenerGuardia: obtenerGuardia,
  obtenerGuardiaRealizada: obtenerGuardiaRealizada,
  obtenerGuardiaCancelada: obtenerGuardiaCancelada,
  tareasTomadasRecurso: tareasRecursoTomadas,
  pausaExcedida: pasusaExcedida,
  reiniciarTarea: reiniciarTarea,
  pausarTarea: pausarTarea,
  obtenerTiposPausa: obtenerTiposPausa,
  listaTareasAbiertasPorUsuarioCaso: TareasAbiertasPorUsuarioCaso,
  actualizarNotificaciones: actualizarNotificaciones,
  itemCasoArchivadoPorId: itemCasoArchivadoPorId,
  itemCasoArchivadoPorIdContext: itemCasoArchivadoPorIdContext,
  listaTareasActivasCasoPorUsuario: listaTareasActivasCasoPorUsuario,
  listaTareasNoTomadasCaso: TareasNoTomadasCaso,
  listaTareasEnEjecucionCaso: TareasEnEjecucionCaso,
  listaTareasCompletadasPorUsuario: TareasCompletadasPorUsuario,
  listaTareasCompletadasCasoPorUsuario: TareasCompletadasCasoPorUsuario,
  listaTareasAbiertasTomadasPorUsuario: TareasAbiertasTomadasPorUsuario, tareasAbiertasTomadasUsuario: listaTareasAbiertasTomadasUsuario,
  tareasCompletadasUsuario: listaTareasCompletadasUsuario,
  itemCasosPorClientet: itemCasosPorClientet,
  itemComentariosCasoActivo: itemComentariosCasoActivo,
  itemComentariosCasoArchivado: itemComentariosCasoArchivado,
  itemListaCasosArchivado: itemListaCasosArchivado,
  itemTareasCompletadasPorUsuario: itemListaTareasCompletadasPorUsuario,
  itemListaTareasTomadasPorUsuario: itemListaTareasTomadasPorUsuario,
  itemRecursoContexto: itemRecursoContexto,
  itemTareasCasoActivo: itemTareasCasoActivo,
  obtenerUsuarios: obtenerUsuarios,
  itemTipoTicketPorCliente: itemTipoTicketPorCliente,
  oauthAzure: login,
  itemPonderacion: itemPonderacion,
  itemSaldoClearing: itemSaldoClearing,
  itemAcountManagerSaldoClearing: itemAcountManagerSaldoClearing,
  itemClienteResultado: itemClienteResultado,
  itemClienteResultados: itemClienteResultados,
  ticketModificar: ticketModificar,
  itemProcesoPorCliente: itemProcesoPorCliente,
  modificarUsuario: modificarUsuario,
});

export type RootState = ReturnType<typeof rootReducers>; // Definimos el tipo RootState para su uso posterior

export default rootReducers;
